export default class{
  constructor({
    handle,
    quoteContainer,
    quoteSelector,
    navSelector
  }) {
    let quoteCont = document.querySelector(quoteContainer),
        activeQuote = quoteCont.querySelector(quoteSelector + '.active'),
        navCont = document.querySelector(navSelector),
        iconNext = navCont.querySelector(navSelector + '__icon-next'),
        iconPrevious = navCont.querySelector(navSelector + '__icon-previous'),
        navIcons = [iconNext, iconPrevious];

    const shiftNext = (quote) => {
      var nextTarget;
      // If there is a next sibling, make it the target
      if (nextTarget = quote.nextElementSibling) {
        quote.classList.remove('active');
        nextTarget.classList.add('active');
        activeQuote = nextTarget;
      } // Else make nextTarget the first child of the container (first quote)
      else {
        nextTarget = quoteCont.children[0];
        quote.classList.remove('active');
        nextTarget.classList.add('active');
        activeQuote = nextTarget;
      }
    }

    const shiftPrev = (quote) => {
      var prevTarget;
      // If there is a previous sibling, make it the target
      if (prevTarget = quote.previousElementSibling) {
        quote.classList.remove('active');
        prevTarget.classList.add('active');
        activeQuote = prevTarget;
      } // Else make prevTarget the last child of the container (last quote)
      else {
        prevTarget = quoteCont.children[quoteCont.children.length - 1];
        quote.classList.remove('active');
        prevTarget.classList.add('active');
        activeQuote = prevTarget;
      }
    }

    const handleQuoteChange = (e) => {
      // If it doesn't have either class, return early
      if (! (e.currentTarget.classList.contains('js-next') || e.currentTarget.classList.contains('js-prev')))
        return;

      // If it's the next icon
      if (e.currentTarget.classList.contains('js-next')) {
        shiftNext(activeQuote);
        return;
      }

      // If it's the prev icon
      shiftPrev(activeQuote);
    }

    navIcons.forEach(icon => {
      icon.addEventListener('click', function(e) {
        handleQuoteChange(e);
      })
    });
}}